/**
 * @generated SignedSource<<aa2c107ba228bc36d64b40daef196910>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthenticationSamlForm_samlAuth",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "signInUrl",
      "storageKey": null
    }
  ],
  "type": "SsoSamlAuthenticationConfig",
  "abstractKey": null
};

node.hash = "03f2e057c5690f478c3d2349ab8bf3d4";

module.exports = node;
